module.exports = __webpack_public_path__ + "assets/icon-loan-rejected.svg";